// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"22":"518593c15e26ba927b95","71":"54588d7166cf4fd7e87f","452":"5a508e2d082324394234","885":"86e5dfba28dc0eadab2b","961":"e3d9053b76a0c2420c7d"}[chunkId] + ".css";
};